import { Box } from '@mui/material'
import { DropDown } from 'Common/Supplyvue-ui'
import {
  BaseSourceSiteWorkCentre,
  useSettingsContext,
} from 'Features/Projects/Scenarios/EditSettings/EditSettings.types'
import { useBaseSourceSiteWorkCentre } from './EditSettings.data'

export const EditSettingsDataFilter = () => {
  const { state, dispatch } = useSettingsContext()
  const { selectedWorkCentre, selectedBaseSourceSite, projectId, scenarioId } = state
  
  const { data: baseSourceSiteData = [] } = useBaseSourceSiteWorkCentre({
    projectId,
    scenarioId,
  })

  const groupWorkcentresBySite = (
    data: BaseSourceSiteWorkCentre[]
  ): Record<string, string[]> => {
    return Object.fromEntries(
      Object.entries(
        data.reduce((acc, item) => {
          ;(acc[item.baseSourceSiteCode] ||= new Set()).add(item.workcentreCode)
          return acc
        }, {} as Record<string, Set<string>>)
      ).map(([key, value]) => [key, [...value]])
    )
  }

  const groupedData = groupWorkcentresBySite(baseSourceSiteData)

  const baseSourceSiteOptions = Object.keys(groupedData).map((site) => ({
    label: site,
    value: site,
  }))

  const AllOption = { label: 'All', value: 'All' }

  const workCentreOptions =
    selectedBaseSourceSite && selectedBaseSourceSite !== 'All' && groupedData[selectedBaseSourceSite]
      ? groupedData[selectedBaseSourceSite].map((wc) => ({
          label: wc,
          value: wc,
        }))
      : selectedBaseSourceSite === 'All' 
        ? // Show all work centres when "All" is selected for base source site
          [...new Set(baseSourceSiteData.map(item => item.workcentreCode))].map((wc) => ({
            label: wc,
            value: wc,
          }))
        : []

  const allWorkcentreOptions = [AllOption, ...workCentreOptions]
  const allBaseSourceSiteOptions = [AllOption, ...baseSourceSiteOptions]

  const handleOnChange = (e: any) => {
    const { value, name } = e.target
    if (value === 'All') {
      dispatch({
        type: 'RESET_DROPDOWN_OPTIONS',
      })
    } else {
      dispatch({
        type:
          name === 'baseSourceSite'
            ? 'UPDATE_BASE_SOURCE_SITE'
            : 'UPDATE_WORKCENTRE',
        payload: e.target.value as string,
      })
    }
  }

  return (
    <Box display="flex" flexDirection="row" gap="16px" sx={{ marginBottom: '16px' }}>
      <Box sx={{ width: '175px' }}>
        <DropDown
          label={'BaseSourceSite'}
          name={'baseSourceSite'}
          menuItems={allBaseSourceSiteOptions}
          fullWidth={true}
          value={selectedBaseSourceSite || 'All'}
          onChange={handleOnChange}
          formControlSx={{
            minHeight: '40px',
            height: 'auto',
          }}
          sx={{
            height: '40px',
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: 'rgba(0, 0, 0, 0.23) !important',
                borderWidth: '1px !important',
                borderStyle: 'solid !important',
              },
              '&:hover fieldset': {
                borderColor: 'rgba(0, 0, 0, 0.87) !important',
                borderWidth: '1px !important',
                borderStyle: 'solid !important',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#1976d2 !important',
                borderWidth: '2px !important',
                borderStyle: 'solid !important',
              },
            },
          }}
        />
      </Box>
      <Box sx={{ width: '175px' }}>
        <DropDown
          label={'workCentreCode'}
          name={'workcentre'}
          menuItems={allWorkcentreOptions}
          fullWidth={true}
          value={selectedWorkCentre || 'All'}
          onChange={handleOnChange}
          formControlSx={{
            minHeight: '40px',
            height: 'auto',
          }}
          sx={{
            height: '40px',
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: 'rgba(0, 0, 0, 0.23) !important',
                borderWidth: '1px !important',
                borderStyle: 'solid !important',
              },
              '&:hover fieldset': {
                borderColor: 'rgba(0, 0, 0, 0.87) !important',
                borderWidth: '1px !important',
                borderStyle: 'solid !important',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#1976d2 !important',
                borderWidth: '2px !important',
                borderStyle: 'solid !important',
              },
            },
          }}
        />
      </Box>
    </Box>
  )
}
